import React from "react"
import CustomPageHeader from "../../fragments/CustomPageHeader"

export default function LoanCommission({ children }) {
  return (
    <div>
      <CustomPageHeader icon='tags' text='Loan commissions' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Accounting/LoanCommission/index.js